module.exports = __webpack_public_path__ + "img/section1_img2.4d556ca8.png";